import { useState, useEffect } from 'react';
import { Toolbar, Box, TextareaAutosize, Stack, FormControl, Button, Select, MenuItem } from '@mui/material';
 import DeleteIcon from '@mui/icons-material/Delete';
 import AddIcon from '@mui/icons-material/Add';
 import RemoveIcon from '@mui/icons-material/Remove';
 import ClearIcon from '@mui/icons-material/Clear';
 import HttpsIcon from '@mui/icons-material/Https';
 import moment from 'moment';
import 'moment/dist/locale/de';
import { colorStyle, colorStyleHex, getGenderK, getGenderCol } from './farbschema.js';
import EditGast from './edit_gast';
import EditDates from './edit_dates';
import EditProps from './edit_props';
import EditPayment from './edit_payment';
import EditBed from './edit_bed';
import dataProvider from '../../lib/dataProvider';
 
const EditReservation = ({showOpen, closeEdit, agenten, bookingchannels, alterskats, gastdetails, 
  rowList, gridData}) => {
  const [resInfo, setResInfo] = useState({tgast:{}});
  const [resChange, setResChange] = useState({gaeste:{}});
  const [roomInfo, setRoomInfo] = useState([]);
  const [init, setInit] = useState(false);
  const [bedInfo, setBedInfo] = useState([]);
  const [subEdit, setSubEdit] = useState('');
  const [editBed, setEditBed] = useState(false);
  const [selAddBed, setSelAddBed] = useState([]);
  const [countries, setCountries] = useState([]);
  const [services, setServices] = useState([]);
  const [addService, setAddService] = useState(false);
  const [paydata, setPaydata] = useState({type:1, amount:0});

  const states = ['Normal', 'Preliminary', 'Fixed', 'Checkin', 'NoShow', 'Storno', 'CheckedOut'];

  useEffect(() => {
    dataProvider.getList('setCountry', { filter: {   }, sort: false, pagination: { page: 1, perPage: 999 } })
      .then(response => { if (response.data) { setCountries(response.data);}
    });
  }, []);

  useEffect(() => {
    if (!showOpen) return;
    if (showOpen.id>0) {
      dataProvider.getOne('appReservation', { id: showOpen.id})
        .then(response => {
          if (response.data) {
            setResInfo(response.data);
            const betten= [];
            for (let i = 0; i < response.data.betten.length; i++) {
              betten[i] = {};
            }
            setResChange({gaeste:{},betten: betten, services: [], zahlung: []});
          }
        });
    }
    else if (showOpen.info) {
      setInit(true);
      setResInfo(showOpen.info);
      const betten= [];
      for (let i = 0; i < showOpen.info.betten.length; i++) {
        betten[i] = {}; 
      }
      setResChange({ankunft:showOpen.info.ankunft,dauer:showOpen.info.dauer,gaeste:{},betten: betten, services: [], zahlung: []});
    }
  }, [showOpen]);

  useEffect(() => {
    if (!showOpen.id  || (showOpen.id===-1 && !getInfo('ankunft'))) return
    dataProvider.getList('appBettinfo', {
      filter: { id_reservation: showOpen.id, start: getInfo('ankunft'), duration: getInfo('dauer') },  sort: false,  pagination: { page: 1, perPage:  777}
    })
    .then(response => {
      if (response.data) {
        const bedlist = [...response.data].filter(x => x.belegt===0);
        getInfoBetten().forEach((b, k) => { 
          const f = bedlist.findIndex(x => x.bett_id === b.bett_id);
          if (f > -1) {
            bedlist.splice(f, 1);
          }
        });
        setBedInfo(bedlist);
      }
    });
    const params = {
      filter: { id_reservation: showOpen.id, start: resChange.ankunft, duration: resChange.dauer },  sort: false,  pagination: { page: 1, perPage: 999 }
    };
    dataProvider.getList('appRoominfo', params).then(response => { if (response.data) { setRoomInfo(response.data); }});
    dataProvider.getList('appService', params).then(response => { if (response.data) { setServices(response.data); }});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOpen, resChange.ankunft, resChange.dauer]);

  useEffect(() => {
    if (!bedInfo.length || !roomInfo.length || !init) return
    setInit(false);
    recalcPrices();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bedInfo, roomInfo]);

  const getAbk = (id) => {
    return countries.find(x => x.id === id)?.abk;
  }
  const getGastInfo = (gastid, field) => {
    const gastinfo = getInfoGast(gastid);
    return gastinfo[field];
  }
  const closeGast = () => {
    setSubEdit('');
//    setResInfo(ri=>({...ri, tgast: gastInfo}));
  }

  const close = () => {
    setSubEdit('');
  }

  const getInfoBetten = () => {
    if (!resInfo?.betten) return [];
    const res = [...resInfo.betten];
    if (resChange.betten) {
      resChange.betten.forEach((bc, k)=>{
        if (!res[k]) res[k] = {};
        for (const p in bc) {
          res[k][p] = bc[p];
        }
      })
    }
    return res;
  }

  const getInfo = (field, field2) => {
    let value = '';

    if (field2) {
      if (resChange[field] && resChange[field][field2]) {
        value = resChange[field][field2];
      }
      else {
        value = resInfo[field][field2];
      }
    }
    else {
      if (resChange[field]) {
        value = resChange[field];
      }
      else {
        value = resInfo[field];
      }
    }
    return value;    
  }

  const getChanged = (field, field2) => {
    let changed = false;
    if (field2) {
      if (resChange[field] && resChange[field][field2]) {
        changed = true
      }
    }
    else {
      if (resChange[field]) {
        changed = true
      }
    }
    return changed?'changed':'';    
  }

  const getChangedGast = (gastid, field) => {
    if (!gastid) {
      gastid = resInfo.id_gast;
    }
    let changed = false;
    if (resChange?.gaeste && resChange.gaeste[gastid] && resChange.gaeste[gastid][field]) {
      changed = true
    }
    return changed?'changed':'';
  }
        
        
  const getInfoServices = () => {
    if (!services) return [];
    const res = [...services];
    res.forEach((bc, k)=>{ bc.anzahl = 0;});
    if (resInfo.services) {
      Object.entries({...resInfo.services, ...resChange.services}).forEach((bc)=>{
        if (res.findIndex(x => x.id === parseInt(bc[0]))>-1) {
          res.find(x => x.id === parseInt(bc[0])).anzahl = bc[1];
        }
      })
    }
    return res;
  }

  const addServiceCnt = (id, v) => () => {
    const cnt = v===0?0:getInfoServices().find(x => x.id === id).anzahl + v;
    setResChange(rc=>({...rc, services: {...rc.services, [id]: cnt} })); 
  }

  const clickServiceDef = (id) => () => {
    const z = getInfoServices().find(x => x.id === id);
    setResChange(rc=>({...rc, services: {...rc.services, [id]: getServiceDefCnt(z)} }));
  }

  const getInfoPayments = () => {
    if (!resInfo?.zahlung) return [];
    return [...resInfo.zahlung, ...resChange.zahlung];
  }

        
  const getInfoGast = (gastid) => {
    if (!gastid) {
      gastid = getInfo('id_gast');
    }
    const res = resInfo?.gaeste[gastid]?{...resInfo.gaeste[gastid]}:{};
    if (resChange?.gaeste && resChange.gaeste[gastid]) {
      for (const k in resChange.gaeste[gastid]) {
        res[k] = resChange.gaeste[gastid][k];
      }
    }
    return res;
  }

  const updateGastValue = (gastid, field, value) => {
    if (!gastid) {
      gastid = getInfo('id_gast');
    }
    const oi = resInfo?.gaeste[gastid];
    const ov = oi?oi[field]:'';

    if (field === 'pass' && value.includes('<<')) {
      dataProvider.getOne('appPassreader', { id:value })
        .then(response => { 
          if (response.data) { 
            const res = response.data;
            if (!res.err) {
              const pd = res.passdata;
            console.log(res);
              const gdata = {vorname:pd.vornamen, name:pd.name, pass:pd.passnummer, id_passland:pd.id_passland, geburtsdatum:pd.geburtsdatum,
                'det-515-4':pd.dokumenttyp, 'det-515-5':pd.geschlecht, 'det-515-6':pd.ablaufdatum, 
              };
              setResChange(ri=>({...ri, gaeste:{...ri.gaeste, [gastid]:{...ri.gaeste[gastid], ...gdata}}}));
            }
            return;
          }
      });
    }

    if (value === ov) {
      if (resChange?.gaeste && resChange.gaeste[gastid]) {
        setResChange(ri=>{ 
          const nd = {...ri}; 
          delete nd.gaeste[gastid][field]; 
          return nd;
        });
      }
    }
    else {
      setResChange(ri=>({...ri, gaeste:{...ri.gaeste, [gastid]:{...ri.gaeste[gastid], [field]:value}}}));
    }
  }

  const loadGast = (gastid) => {
    if (resInfo?.gaeste[gastid]) return;
    dataProvider.getOne('appFindguest', { id:gastid })
      .then(response => {
        if (response.data) {
          setResInfo(ri=>({...ri, gaeste:{...ri.gaeste, [gastid]:response.data}}));
        }
    })
  }
  
  const getChangedBetten = (id, field) => {
    let changed = false;
    const b = getInfoBetten();
    const f = b.findIndex(x => x.bett_id === id);
    if (f < 0) return '';
    if (field in resChange.betten[f]) {
      changed = true
    }
    return changed?'changed':'';    
  }
        
  const updateChanged = (value, field, field2) => {
    if (field2) {
      if (value === resInfo[field][field2]) {
        setResChange(ri=>{ 
          const nd = {...ri}; 
          delete nd[field][field2]; 
          return nd;
        });
      }
      else {
        setResChange(ri=>({...ri, [field]:{...ri[field], [field2]:value}}));
      }
    }
    else {
      if (value === resInfo[field]) {
        setResChange(ri=>{ 
          const nd = {...ri}; 
          delete nd[field]; 
          return nd;
        });
      }
      else {
        setResChange(ri=>({...ri, [field]:value}));
      }
    }
  }

  const toggleGender = (k) => () => {
    const g = (getInfoBetten()[k].geschlecht+1)%4;
    setResChange(rc=>{
      const betten = [...rc.betten];
      betten[k].geschlecht = g;
      return ({...rc, betten: betten});
    });
  }

  const toggleAgecat = (k) => () => {
    const id = getInfoBetten()[k].alterskat_id
    let x = alterskats.findIndex(a=>a.id===id);
    x = (x + 1) % alterskats.length;
    setResChange(rc=>{
      const betten = [...rc.betten];
      betten[k].alterskat_id = alterskats[x].id;
      betten[k].alterskat = alterskats[x].abk;
      return ({...rc, betten: betten});
    });
  }

  const changeSelBed = (e) => {
    const value = e.target.value;
    setSelAddBed(typeof value === 'string' ? value.split(',') : value);
  }
  const addBed = (addlist) => {
    const empty = !!addlist;
    if (!addlist) addlist = selAddBed;
    if (!showOpen.id) return
    if (!addlist.length) return
    const params = { sel: addlist, empty, id_reservation: showOpen.id, start: getInfo('ankunft'), duration: getInfo('dauer') };
    dataProvider.getList('appBettinfo', { filter: params, sort: false, pagination: { page: 1, perPage: 999 }, })
    .then(response => {
      if (response.data) {
        setSelAddBed([]);
        const bett = response.data;
        setResChange(rc=>({...rc, betten: [...rc.betten, ...bett]}));
        const bedlist = [...bedInfo];
        bett.forEach((b, k) => { 
          const f = bedlist.findIndex(x => x.bett_id === b.bett_id);
          if (f > -1) {
            bedlist.splice(f, 1);
          }
        });
        setBedInfo(bedlist);
      }
    });
  }
  
  const addPrivate = () => {
    const beds = getInfoBetten();
    const addlist = [];
    beds.forEach((b) => {
      rowList.forEach((r) => {
        if (beds.findIndex(x => x.bett_id === r.bett_id) > -1) return;
        if (b.id_zimmer === r.id_zimmer) {
          if (!gridData[r.bett_id]) return;
          let belegt = Object.entries(gridData[r.bett_id]).reduce((pv, cv) => {
            return ((cv[1].abreise>getInfo('ankunft') && cv[1].ankunft<getInfo('abreise') && cv[1].id_person>0) || pv)
          }, false);
          if (!belegt && !addlist.includes(r.bett_id)) {
            addlist.push(r.bett_id);
          }
        }
      })
    });
    addBed(addlist);
    console.log(['addlist', addlist]);
  }
  const recalcPrices = () => {
    const beds = getInfoBetten();
    const rcb = [...resChange.betten];
    const zbel = {};
    beds.forEach((b, k) => {
      const zid = b.id_zimmer;
      if (!zbel[zid]) {
        zbel[zid] = {belegung:0, personen:0};
      }
      if (b.geschlecht !== 3) {
        zbel[zid].personen++;
      }
      zbel[zid].belegung++;
    });


    beds.forEach((b, k) => {
      let bel = 0;
      const zid = b.id_zimmer;
      if (zbel[zid].belegung >= roomInfo.find(x=>x.id===zid)?.anzbett) {
        bel = zbel[zid].personen;
      }
      let preis = 0;
      const preise = roomInfo?.find(x=>x.id===b.id_zimmer)?.preise;
      if (preise) {
        preis = preise.find(x=>x.belegung===bel && x.id_alterskat===b.alterskat_id)
      }
      if (preise && !preis) {
        preis = preise.find(x=>x.belegung===0 && x.id_alterskat===b.alterskat_id)
      }
      if (preise && !preis) {
        preis = preise.find(x=>x.belegung===bel && x.id_alterskat===alterskats[0].id)
      }
      if (preise && !preis) {
        preis = preise.find(x=>x.belegung===0 && x.id_alterskat===alterskats[0].id)
      }
      if (preise && preis) {
        if (!rcb[k]) rcb[k] = {};
        rcb[k].preis = preis.preis;
      }
      if (b.geschlecht === 3) {
        rcb[k].preis = 0;
      }
    }) 
    setResChange(rc=>({...rc, betten: rcb}));
  }

  const delBed = (k) => () => {
    setResChange(rc=>{
      const betten = [...rc.betten];
      betten[k].del = true;
      return ({...rc, betten: betten});
    });
  }

  const addPayment = (pd) => {
    setResChange(rc=>({...rc, zahlung:[...rc.zahlung, {...pd}]}));
  }

  const getServiceDefCnt = (z) => {
    let dauer = getInfo('dauer');
    let mod = {};
    if (z.anz_modifier !== "") {
      const fields = z.anz_modifier.replace("\r\n", "|").replace("\r", "|").replace("\n", "|").split("|");
      fields.forEach((v) => { const s = v.split("="); mod[s[0]] = s[1]; });
    }
    if (mod.ServiceCondLimitNightsMax) {
      dauer = Math.min(dauer, parseInt(mod.ServiceCondLimitNightsMax));
    }
    let akAllow = [];
    if (mod.ServiceCondConnectedAgecategories) {
      akAllow = mod.ServiceCondConnectedAgecategories.split(",").map(str => parseInt(str));
    }
    let pkAllow = [];
    if (mod.ServiceCondConnectedRoomtypes) {
      pkAllow = mod.ServiceCondConnectedRoomtypes.split(",").map(str => parseInt(str));
    }
    let agentAllow = [];
    if (mod.ServiceCondConnectedAgent) {
      agentAllow = mod.ServiceCondConnectedAgent.split(",").map(str => parseInt(str));
    }
    
    // personen zaehlen
    let personen = 0;
    let preis = 0;
    infoBetten.forEach((b) => {
      if (pkAllow.length>0 && !pkAllow.includes(b.id_preiskat)) return;
      if (akAllow.length>0 && !akAllow.includes(b.alterskat_id)) return;
      if (b.geschlecht !== 3) personen++;
      preis += b.preis;
    })

    let res = z.def_anz?z.def_anz:1;
    switch (z.def_type) {
      case 1: //ZT_Nigths:
        res *= dauer;
        break;
      case 2: //ZT_Persons:
        res *= personen;
        break;
      case 3: //ZT_NightsAndPersons:
          res *= dauer * personen;
        break;
      case 4: //ZT_NetPrice:
          res *= preis * dauer;
        break;
      case 5: //ZT_PricePerNight:
        res *= preis;
        break;
      case 6: //ZT_SerivcePrice:
        {
          //QString sTemp = clNumber::Mul(dauer, sPersonen);
          //newval = clNumber::Mul(newval, sTemp);
        }
        // noch nicht implementiert:
        //break;
        // falls through
      default:
        if (true /*allowZeroDefault*/) {
          res = z.def_anz;
        }
    }

    if (mod.ServiceCondMinNights && getInfo('dauer')<parseInt(mod.ServiceCondMinNights)) {
      res = 0;
    }
    if (mod.ServiceCondMaxNights && getInfo('dauer')>parseInt(mod.ServiceCondMaxNights)) {
      res = 0;
    }
    if (agentAllow.length>0 && !agentAllow.includes(getInfo('id_agent'))) {
      res = 0;
    }    
    return res;
  }

  console.log(['resInfo', resInfo]);
  console.log(['reschange', resChange]);
  if (!(resInfo?.id)) return null;

  const infoBetten = getInfoBetten();
  const infoServices = getInfoServices()
  const netprice = infoBetten.reduce((pv, cv) => pv + cv.preis, 0) * getInfo('dauer');
  const serviceprice = infoServices.reduce((pv, cv) => pv + cv.avgpreis * cv.anzahl, 0);
  const infoPayments = getInfoPayments();
  const paied = (infoPayments?infoPayments.reduce((pv, cv) => pv + cv.betrag, 0):0);
  let offen = netprice + serviceprice - paied;

  console.log(['infoPayments', infoPayments])

  return (
    <>
      <Stack className="textdisp" direction="row" spacing={2} style={{alignItems: "flex-end"}} sx={{minWidth:"450px"}}>
        <Toolbar sx={{backgroundColor:"#eee"}}><Button variant="contained" onClick={closeEdit}>Cancel</Button></Toolbar>
        <Toolbar sx={{backgroundColor:"#eee"}}><Button variant="contained" onClick={closeEdit}>Save</Button></Toolbar>
      </Stack>
        <Stack className="textdisp clickable" direction="row" spacing={2} style={{alignItems: "flex-end"}} onClick={()=>{setSubEdit('gast')}}>
          <span>Main guest for {resInfo.res_nr>-1?'#'+resInfo.res_nr:'new reservation'}</span>
          <span className={getChangedGast(0, 'vorname')} style={{fontSize:'1.5em'}}>{getGastInfo(0, 'vorname')}</span>
          <span className={getChangedGast(0, 'name')} style={{fontSize:'1.5em'}}>{getGastInfo(0, 'name')}</span>
          <span className={getChangedGast(0, 'id_land')}>{getAbk(getGastInfo(0, 'id_land'))}</span>-<span className={getChangedGast(0, 'id_passland')}>{getAbk(getGastInfo(0, 'id_passland'))}</span>
        </Stack>
        <Stack className="textdisp clickable" direction="row" spacing={2} onClick={()=>{setSubEdit('dates')}} style={{alignItems: "flex-end", flexWrap: 'wrap' }}>
          <span>Dates</span>
          <span className={getChanged('ankunft')}>{moment(getInfo('ankunft')+'').format('dd MMMM Do YYYY')}</span>
          <span className={getChanged('dauer')}>{getInfo('dauer')} Night{getInfo('dauer')>1?'s':''}</span> 
          <span className={getChanged('abreise')}>{moment(getInfo('ankunft')+'').add(getInfo('dauer'), 'days').format('dd MMMM Do YYYY')}</span>
        </Stack>
        <Stack className="textdisp clickable" direction="row" spacing={2}  onClick={()=>{setSubEdit('props')}} style={{alignItems: "flex-end", flexWrap: 'wrap' }}>
        <span>Flags</span>
        <span>State: <span className={getChanged('status')}>{states[getInfo('status')]}</span></span>
          <span>Agent: <span className={getChanged('id_agent')}>{agenten.find(a=>a.id_agent===getInfo('id_agent'))?.firma}</span></span>
          <span>Booked by: <span className={getChanged('id_buchungskanal')}>{bookingchannels.find(c=>c.id===getInfo('id_buchungskanal'))?.bezeichnung}</span></span>
          {getInfo('wichtig') && <span className={getChanged('wichtig')}>Important</span>} 
          {getInfo('erinnerung')>0 && <span className={getChanged('erinnerung')}>Reminder: {moment(getInfo('erinnerung')+'').format('DD.MM.YYYY')}</span>}
        </Stack>
        <div className="textdisp">
          <span className={getChanged('bemerkung')}>Remarks</span>
          <TextareaAutosize  maxRows={8} minRows={2} value={getInfo('bemerkung')} onChange={(e)=>{updateChanged(e.target.value, 'bemerkung')}} 
            style={{width:"100%", border:'none', backgroundColor:'#eee', fontFamily:'inherit', fontSize:'inherit'}} />
        </div>
        <div className="textdisp">
          <span>Beds</span>
          <table style={{width:"100%"}}>
            <tbody>
      {infoBetten && resInfo.betten.length > 0 && infoBetten.map((z, k) => {
        if (z.del) return null;
        return (
              <tr key={z.id_person} className='clickable'>
                <td className={resChange?.betten && resChange.betten.findIndex(b=>b.bett_id===z.bett_id) > -1 ? 'changed' : ''} onClick={()=>{setEditBed(k)}} >{z.bezeichnung}{z.buchstabe}</td>
                <td className={getChangedBetten(z.bett_id, 'geschlecht')} style={colorStyleHex(getGenderCol(z.geschlecht))} onClick={toggleGender(k)}>{getGenderK(z.geschlecht)}</td>
                <td className={getChangedBetten(z.bett_id, 'alterskat')} onClick={toggleAgecat(k)}>{alterskats.find(a=>a.id===z.alterskat_id)?.abk}</td>
                <td onClick={()=>{setEditBed(k)}}>{z.pkbez}</td>
                <td className={getChangedBetten(z.bett_id, 'preis')} onClick={()=>{setEditBed(k)}} style={{textAlign:'right'}}>{parseFloat(z.preis).toFixed(2)}</td>
                <td onClick={()=>{setEditBed(k)}}>{getGastInfo(z.id_gast, 'vorname')} {getGastInfo(z.id_gast, 'name')} {getAbk(getGastInfo(z.id_gast, 'id_land'))}-{getAbk(getGastInfo(z.id_gast, 'id_passland'))}</td>
                <td onClick={delBed(k)}><DeleteIcon /></td>
              </tr>
      )
      })}          
            </tbody>
          </table>
          <Stack direction="row" gap={2} sx={{alignItems: "center"}}>
            <FormControl sx={{ m: 0, width: '60%', '& .MuiSelect-select': { p: '4px' } }} size="small">
              <Select value={selAddBed} onChange={changeSelBed} multiple style={{p:0}}>
                <option value={0}>Select Bed</option>
                {bedInfo.map((bed) => {
                  return (
                    <MenuItem key={bed.bett_id} value={bed.bett_id} style={{display:'grid', gridTemplateColumns: 'auto 10% 50%'}}>
                      <span style={{...colorStyle(bed.farbe), padding:'0 0.3em'}}>{bed.bezeichnung}{bed.buchstabe}</span> 
                      <span></span>
                      <span style={{...colorStyle(bed.pkfarbe), padding:'0 0.3em'}}>({bed.kurzbez})</span>
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
            <Button variant="outlined" onClick={()=>addBed()} style={{whiteSpace:'nowrap'}}>Add Bed</Button>
            <HttpsIcon onClick={addPrivate} className="clickable" />
            <svg onClick={recalcPrices} style={{marginLeft:'auto', padding:'0 0.5em', width:"26px"}} className="clickable"  version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m13 3c-4.97 0-9 4.03-9 9h-3l3.89 3.89 0.07 0.14 4.04-4.03h-3c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-0.79-4.94-2.06l-1.42 1.42c1.63 1.63 3.87 2.64 6.36 2.64 4.97 0 9-4.03 9-9s-4.03-9-9-9"/><path d="m13.451 8.7538v2.2717q0.08527 0.02436 0.48114 0.12181 1.3094 0.34106 1.8515 0.83439 0.66995 0.61513 0.66995 1.6749 0 1.078-0.68822 1.8089-0.43851 0.46896-0.97447 0.68822-0.52987 0.21316-1.3399 0.2558v1.2364h-0.73694v-1.2424q-1.2851-0.073085-2.0098-0.65168-1.011-0.81003-1.0232-2.2839h1.7297q-0.01218 1.4495 1.3034 1.5896v-2.5763q-1.2181-0.34106-1.681-0.60904-0.59077-0.34106-0.86484-0.80394-0.27407-0.46896-0.27407-1.1328 0-0.73694 0.3837-1.3094 0.3837-0.57859 1.0902-0.89529 0.5055-0.22535 1.346-0.28016v-1.0963h0.73694v1.0963q1.2973 0.066995 1.9916 0.72476 0.7004 0.65168 0.72476 1.821h-1.6505q-0.024362-1.1085-1.0658-1.2424zm-0.73694-0.018271q-1.1633 0.10354-1.1633 1.0597 0 0.43242 0.2558 0.66995 0.2558 0.23144 0.90747 0.38979zm0.73694 6.3219q1.2851-0.15835 1.2851-1.1937 0-0.62122-0.49942-0.91356-0.14008-0.08527-0.78566-0.28625z" fill-rule="evenodd" opacity=".82584" stroke-opacity=".80288" stroke-width=".27198" aria-label="$"/></svg>
          </Stack>
        </div>
        <div className="textdisp">
          <span>Services</span>
          <div style={{maxHeight:'14em', overflow:'auto'}}>
            <table style={{width:"100%"}}>
              <tbody>
        {infoServices.map((z) => {
          if (!z.anzahl && !addService) return null;
          const defaultCnt = getServiceDefCnt(z);
          return (
                <tr key={z.id}>
                  <td style={{width:'50%'}} >{z.bezeichnung}</td>
                  <td style={{textAlign:'right', paddingRight:'1em', color:'#999'}} onClick={clickServiceDef(z.id)} className="clickable">{defaultCnt}</td>
                  <td className="clickable">
          {z.def_type!==4 && z.def_type!==5 && <RemoveIcon onClick={addServiceCnt(z.id, -1)} sx={{fontSize:16,top:3,position:'relative'}}/> }
          {(z.def_type===4 || z.def_type===5) && z.anzahl > 0 && <ClearIcon onClick={addServiceCnt(z.id, 0)} sx={{fontSize:16,top:3,position:'relative'}}/> }
                  </td>
                  <td style={{textAlign:'center', backgroundColor:z.anzahl && z.anzahl!==defaultCnt?'#fa0':''}}>{z.anzahl?z.anzahl:''}</td>
                  <td className="clickable">
          {z.def_type!==4 && z.def_type!==5 &&
                    <AddIcon onClick={addServiceCnt(z.id, 1)} sx={{fontSize:16,top:3,position:'relative'}}/>
          }
                  </td>
                  <td style={{textAlign:'right'}}>{parseFloat(z.avgpreis).toFixed(2)}</td>
                  <td style={{textAlign:'right'}}>{(parseFloat(z.avgpreis)*z.anzahl).toFixed(2)}</td>
                </tr>
        )
        })}          
              </tbody>
            </table>
          </div>
          <Box display="flex" justifyContent="right">
            {!addService && <Button variant="outlined" onClick={()=>setAddService(true)} sx={{p:'0 4px'}}>Add Service</Button>}
            {addService && <Button variant="outlined" onClick={()=>setAddService(false)} sx={{p:'0 4px'}}>Hide</Button>}
          </Box>
        </div>
        <div className="textdisp">
          <span>Payments</span>
          <table style={{width:"100%"}}>
            <tbody>
              <tr>
                <td colSpan={3}>Accomodation</td>
                <td className="right">{netprice.toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan={3}>Services</td>
                <td className="right">{serviceprice && serviceprice.toFixed(2)}</td>
              </tr>
        {infoPayments.length>0 && 
              <tr>
                <td colSpan={3}><b>Total</b></td>
                <td className="right"><b>{(netprice + serviceprice).toFixed(2)}</b></td>
              </tr>
        }
        {infoPayments.map((z) => (
              <tr key={z.zahlung_id}>
                <td>{moment.unix(z.datum).format('DD.MM.YYYY HH:mm')}</td>
                <td>{z.text}</td>
                <td>{z.bezeichnung}</td>
                <td className="right">{typeof z.betrag === 'number' ?z.betrag.toFixed(2):'0.00'}</td>
              </tr>
        ))}          
              <tr>
                <td colSpan={3}><b>{infoPayments.length>0?'Due':'Total / Due'}</b></td>
                <td className="right" style={Math.abs(offen)<0.01?{color:'green'}:{color:'red'}}><b>{offen.toFixed(2)}</b></td>
              </tr>
            </tbody>
          </table>
          <Box display="flex" justifyContent="right">
            <Button variant="outlined" onClick={()=>{setPaydata({betrag:offen}); setSubEdit('payment')}} sx={{p:'0 4px'}}>Add Payment</Button>
          </Box>
        </div>
      <EditGast open={subEdit==='gast'} close={closeGast} getInfo={getInfo} getGastInfo={getGastInfo} updateChanged={updateChanged} setResChange={setResChange} updateGastValue={updateGastValue} countries={countries} gastdetails={gastdetails} loadGast={loadGast} getInfoBetten={getInfoBetten} />
      <EditDates open={subEdit==='dates'} close={close} getInfo={getInfo} updateChanged={updateChanged} />
      <EditProps open={subEdit==='props'} close={close} getInfo={getInfo} updateChanged={updateChanged} states={states} agenten={agenten} bookingchannels={bookingchannels} />
      <EditBed open={editBed!==false} pos={editBed} close={()=>setEditBed(false)} getInfoBetten={getInfoBetten} setResChange={setResChange} getInfoGast={getInfoGast} 
        getGastInfo={getGastInfo} updateGastValue={updateGastValue} bedInfo={bedInfo} countries={countries} alterskats={alterskats} roomInfo={roomInfo} loadGast={loadGast} />
      <EditPayment open={subEdit==='payment'} close={close} getInfo={getInfo} updateChanged={updateChanged} paydata={paydata} setPaydata={setPaydata} addPayment={addPayment} />
    </>
  )
}

export default EditReservation